import { SHOW_HEADER_WIDGET, HIDE_HEADER_WIDGET } from './constants';

export const showHeaderWidgetAction = () => ({
  type: SHOW_HEADER_WIDGET,
});

export const hideHeaderWidgetAction = () => ({
  type: HIDE_HEADER_WIDGET,
});
